import { z } from "zod";

/**
 * Formato padrão de erro devolvido pela API.
 * `code` é estável (para o frontend decidir o que fazer);
 * `message` é legível em português.
 */
export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    requestId: z.string().optional(),
    details: z.unknown().optional(),
  }),
});

export type ApiError = z.infer<typeof apiErrorSchema>;
